import React from "react"
import { Button } from "../button"
import { VisuallyHidden } from "../visually-hidden"
import { getColorName } from "./get-color-name"

export type ColorTileProps = {
  color: string
  handleColorSelect: (color: string) => void
}

/**
 * A single color swatch button. Clicking it selects the color. Shared by the
 * "Saved colors" and "In this design" sections.
 */
export function ColorTile({ color, handleColorSelect }: ColorTileProps) {
  const colorName = getColorName(color)

  return (
    <Button
      variant="unstyled"
      className="h-6 w-6 rounded border border-gray-200 hover:border-gray-400"
      style={{ background: color }}
      telemetry={{ action: "select" }}
      onClick={() => handleColorSelect(color)}
    >
      <VisuallyHidden>
        {colorName && colorName !== color
          ? `Select ${colorName}, ${color}`
          : `Select color ${color}`}
      </VisuallyHidden>
    </Button>
  )
}
